import { normalizeSort } from '../utils'
import DriverService from '../services/DriverService'

const state = () => ({
  list: [],
  pagination: {
    page: 1,
    itemsPerPage: 10,
    sortBy: ['date_inicial'],
    sortDesc: [false]
  }
})

const getters = {
  DRIVERS: state => {
    return state.list
  },
  DRIVERS_PAG: state => {
    return state.pagination
  }
}

const mutations = {
  SET_DRIVERS: (state, payload) => {
    state.list = payload
  },
  SET_DRIVERS_PAG: (state, payload) => {
    state.pagination = payload
  },
  DELETE_DRIVER: (state, payload) => {
    payload.status = 0
    payload.status_description = 'Deshabilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ENABLE_DRIVER: (state, payload) => {
    payload.status = 1
    payload.status_description = 'Habilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ADD_DRIVER: (state, payload) => {
    state.list.push(payload)
  },
  UPDATE_DRIVER: (state, payload) => {
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  }
}

const actions = {
  LOAD_DRIVERS: async ({ commit, state }, filter) => {
    try {
      let pagination = {
        'page': state.pagination.page,
        'per-page': state.pagination.itemsPerPage,
        'sort': normalizeSort(state.pagination.sortBy, state.pagination.sortDesc),
        'expand': 'dealer' // Incluir información del dealer
      }

      let currentFilter = {}
      for (let key in filter) {
        if (filter.hasOwnProperty(key)) {
          currentFilter[`filter[${key}]`] = filter[key]
        }
      }

      let { data, status } = await DriverService.get({ ...currentFilter, ...pagination })
      if (status === 200) {
        commit('SET_DRIVERS', data.data)
        return data._meta.totalCount
      }
    } catch (error) {
      window.app.$toast.error('Ocurrió un problema al intentar obtener la lista de driver')
      console.error(error)
    }
  },
  VIEW_DRIVER: async (obj, params) => {
    try {
      // Incluir expand=dealer para obtener información del dealer
      const expandParams = { ...params, expand: 'dealer' }
      let { data, status } = await DriverService.view(expandParams)
      if (status === 200) {
        return data
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar obtener los detalles de los driver')
    }
  },
  ADD_DRIVER: async ({ commit }, payload) => {
    try {
      let { data, status } = await DriverService.post(payload)
      if (status === 201) {
        commit('ADD_DRIVER', data)
        window.app.$toast.success('El conductor ha sido registrado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  UPDATE_DRIVER: async ({ commit }, payload) => {
    try {
      let { data, status } = await DriverService.put(payload)
      if (status === 200) {
        commit('UPDATE_DRIVER', data)
        window.app.$toast.success('El conductor ha sido actualizado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  DELETE_DRIVER: async ({ commit }, payload) => {
    try {
      let { status } = await DriverService.delete(payload)
      if (status === 204) {
        commit('DELETE_DRIVER', payload)
        window.app.$toast.success('El conductor ha sido deshabilitado satisfactoriamente')
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar deshabilitar el usuario')
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
